<template>
  <v-app>
    <!-- App bar for logged out user -->
    <v-app-bar app dark class="mainBGColor" v-if="!$store.state.isUserLoggedIn">
      <v-toolbar-title class="headline text-uppercase">
        <img
          @click="home"
          style="cursor: pointer"
          class="mt-2"
          src="https://1410.nyc3.digitaloceanspaces.com/cuddlyghost/Cuddly_Ghost_Logo_Colors_SOLO_sm_v4.png"
          alt="Cuddly Ghost Logo"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <p style="padding: 5px; font-weight: bold;">{{$store.state.totalNumberInCart}}</p>
        <v-icon @click="goToCart" class="mr-2">mdi-cart</v-icon>
        <v-icon @click="login">mdi-account-circle</v-icon>
      </v-toolbar-items>

      <v-menu bottom left style="margin-left: 1px;">
        <template v-slot:activator="{ on }">
          <v-btn dark flat depressed color="transparent" v-on="on" style="padding:5px; margin:0px;">
            <v-icon>mdi-dots-vertical</v-icon>
            <span>Menu</span>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="home">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item @click="login">
            <v-list-item-title>Login</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goToCart">
            <v-list-item-title>Cart</v-list-item-title>
          </v-list-item>
          <v-list-item @click="faqs">
            <v-list-item-title>FAQs</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- End app bar for logged out user -->

    <!-- App bar for logged in user -->

    <v-app-bar app dark class="mainBGColor" v-if="$store.state.isUserLoggedIn">
      <v-toolbar-title class="headline text-uppercase">
        <img
          @click="home"
          style="cursor: pointer"
          class="mt-2"
          src="https://1410.nyc3.digitaloceanspaces.com/cuddlyghost/Cuddly_Ghost_Logo_Colors_SOLO_sm_v4.png"
          alt="Cuddly Ghost Logo"
        />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <p style="padding: 5px; font-weight: bold;">{{$store.state.totalNumberInCart}}</p>
        <v-icon @click="goToCart" class="mr-2">mdi-cart</v-icon>
        <v-icon @click="dashboard">mdi-account-circle</v-icon>
      </v-toolbar-items>

      <v-menu bottom left style="margin-left: 1px;">
        <template v-slot:activator="{ on }">
          <v-btn dark flat depressed color="transparent" v-on="on" style="padding:5px; margin:0px;">
            <v-icon>mdi-dots-vertical</v-icon>
            <span>Menu</span>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="home">
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dashboard">
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goToCart">
            <v-list-item-title>Cart</v-list-item-title>
          </v-list-item>
          <v-list-item @click="faqs">
            <v-list-item-title>FAQs</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- End app bar for logged in user -->

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},
  data: () => ({}),
  methods: {
    login() {
      this.$router.push("/login");
    },
    home() {
      this.$router.push("/");
    },
    dashboard() {
      this.$router.push("/dashboard");
    },
    faqs() {
      this.$router.push("/faqs");
    },
    goToCart() {
      this.$router.push("/cart");
    }
  }
};
</script>

<style scoped>
.mainBGColor {
  background-color: rgb(41, 41, 41) !important;
}
</style>

